import {types} from './types';

const initialState = {
    view: {},
}

export function keyReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_VIEW_KEYS:
            return { ...state, view: action.payload};
        default:
            return state
    }
}